import { createRoot } from 'react-dom/client';
import { StrictMode, FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@kep-ui-kit/ui-theme';

import App from './app/app';

import './styles.css';
import { MarketingInfoProvider } from '../../../libs/react-feature-marketing-info/src/lib/utils/markerting-info-context';

const queryClient = new QueryClient();
const UntypedThemeProvider: FC<any> = ThemeProvider;

const container = document.getElementById('app');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <StrictMode>
    <BrowserRouter>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <MarketingInfoProvider>
        <UntypedThemeProvider>
          <App />
        </UntypedThemeProvider>
        </MarketingInfoProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);
